interface IOperationType {
  title: string;
  value: boolean | string | number;
}

export const ModeOfCorrespondence: IOperationType[] = [
  {
    title: "Email",
    value: "Email",
  },
  {
    title: "Fax",
    value: "Fax",
  },
  {
    title: "Gateway",
    value: "Gateway",
  },
  {
    title: "SFTP",
    value: "SFTP",
  },
];

export const StudyPhase: IOperationType[] = [
  {
    title: "Phase I",
    value: "Phase I",
  },
  {
    title: "Phase Ia",
    value: "Phase Ia",
  },
  {
    value: "Phase Ib",
    title: "Phase Ib",
  },
  {
    title: "Phase II",
    value: "Phase II",
  },
  {
    title: "Phase IIa",
    value: "Phase IIa",
  },
  {
    title: "Phase IIb",
    value: "Phase IIb",
  },
  {
    title: "Phase III",
    value: "Phase III",
  },
  {
    title: "Phase IV",
    value: "Phase IV",
  },
  {
    title: "Other",
    value: "Other",
  },
];
export const StudyType: IOperationType[] = [
  {
    title: "Clinical Trial",
    value: "Clinical Trial",
  },
  {
    title: "Post Approval Study",
    value: "Post Approval Study",
  },
  {
    value: "BA/BE Study",
    title: "BA/BE Study",
  },
  {
    title: "Non-Interventional Study",
    value: "Non-Interventional Study",
  },
  {
    title: "Investigator Initiated Study",
    value: "Investigator Initiated Study",
  },
  {
    title: "Other",
    value: "Other",
  },
];


export const BlindingTechinique: IOperationType[] =[
  { 
    title: "Open Label",
     value: "Open Label" 
    },
  { 
    title: "Single Blind", 
    value: "Single Blind"
   },
  { 
    title: "Double Blind",
     value: "Double Blind"
     },
  { 
    title: "Triple Blind",
     value: "Triple Blind" 
    }, 
]

export const Blinded: IOperationType[] =[
  { 
    title: "YES",
     value: true 
    },
  { 
    title: "NO", 
    value: false
   },
]